'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserIntegrationOAuth } from '../../Entities/User/UserIntegrationOAuth';
import { UserIntegrationProvider } from '../../Entities/User/UserIntegrationProvider';
import { UserIntegrationProviderCollection } from '../../Collections/User/UserIntegrationProviderCollection';

export class UserIntegrationProviderRepository extends CoreRepository {
  public getUserIntegrationFeatureAvailability(userId: number, feature: string) {
    return this.webAPI.getUserIntegrationFeatureAvailability(userId, feature).then((response) => {
      const userIntegrationProviderCollection = new UserIntegrationProviderCollection();

      response.forEach((integrationProvider) => {
        const userIntegrationProvider = new UserIntegrationProvider();
        userIntegrationProvider.hydrate(integrationProvider);

        userIntegrationProviderCollection.addItem(userIntegrationProvider);
      });

      return userIntegrationProviderCollection;
    });
  }

  public getUserIntegrationByFeature(userId: number, feature: string) {
    return this.webAPI.getUserIntegrationByFeature(userId, feature).then((response) => {
      const userIntegrationProviderCollection = new UserIntegrationProviderCollection();

      response.forEach((integrationProvider) => {
        const userIntegrationProvider = new UserIntegrationProvider();
        userIntegrationProvider.hydrate(integrationProvider);

        userIntegrationProviderCollection.addItem(userIntegrationProvider);
      });

      return userIntegrationProviderCollection;
    });
  }

  public getUserIntegrationProvider(userIntegrationProviderId: number, options: object = {}) {
    return this.webAPI
      .getUserIntegrationProvider(userIntegrationProviderId, options)
      .then((userIntegrationProviderResponse) => {
        const userIntegrationProvider = new UserIntegrationProvider();
        userIntegrationProvider.hydrate(userIntegrationProviderResponse);

        return userIntegrationProvider;
      });
  }
}
